import { Navigate } from "react-router-dom";
import { useUserRoles } from "@/hooks/useUserRoles";
import { ForgePageLoader } from "@/components/ForgeLoader";

interface StaffRouteProps {
  children: React.ReactNode;
}

export function StaffRoute({ children }: StaffRouteProps) {
  const { isStaff, isLoading, isFetching } = useUserRoles();

  if (isLoading) {
    return <ForgePageLoader />;
  }

  if (isStaff) {
    return <>{children}</>;
  }

  if (isFetching) {
    return <ForgePageLoader />;
  }

  return <Navigate to="/403" replace />;
}
